module.exports = __webpack_public_path__ + "static/media/header-bg-white-full.5279896d.png";